export const getSelectValue = (options, values) => {
    if (!values || !Array.isArray(values)) return [];
    return options.filter((opt) => values.includes(opt.value));
};